module.exports = __webpack_public_path__ + "img/box1.9fdf7a52.png";